var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65078 17.3498H15.3508V16.6498H8.65078V17.3498ZM8.65078 13.3498H15.3508V12.6498H8.65078V13.3498ZM6.80078 20.6998C6.36745 20.6998 6.00911 20.5581 5.72578 20.2748C5.44245 19.9915 5.30078 19.6331 5.30078 19.1998V4.7998C5.30078 4.36647 5.44245 4.00814 5.72578 3.7248C6.00911 3.44147 6.36745 3.2998 6.80078 3.2998H14.6508L18.7008 7.3498V19.1998C18.7008 19.6331 18.5591 19.9915 18.2758 20.2748C17.9924 20.5581 17.6341 20.6998 17.2008 20.6998H6.80078ZM14.3008 7.6998V3.9998H6.80078C6.60078 3.9998 6.41745 4.08314 6.25078 4.2498C6.08411 4.41647 6.00078 4.5998 6.00078 4.7998V19.1998C6.00078 19.3998 6.08411 19.5831 6.25078 19.7498C6.41745 19.9165 6.60078 19.9998 6.80078 19.9998H17.2008C17.4008 19.9998 17.5841 19.9165 17.7508 19.7498C17.9174 19.5831 18.0008 19.3998 18.0008 19.1998V7.6998H14.3008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetReports);
export default __webpack_public_path__ + "static/media/getReports.1f57ada7a8e56ed311c007db6a24dc50.svg";
export { ForwardRef as ReactComponent };